import { Typo } from "@pepperstone/pepper-ui-kit";

import { Spinner } from "../Icons";

export const RedirectSpinner = ({
  redirectText,
}: {
  redirectText?: string;
}) => (
  <div className="z-50 flex flex-col items-center justify-center py-20">
    <Spinner className="h-24 w-24 animate-spin rounded-full" />
    <div className="pt-20">
      <Typo elem="h1" type="subheading" size="md">
        {redirectText}
      </Typo>
    </div>
  </div>
);
